import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ExpansionPanelComponent, ExpansionPanelTitleDirective } from '@progress/kendo-angular-layout';
import { ControlableObjectBasicInfo } from '@cue/api';
import { ControllableObjectsComponent } from '@cue/ui';
import { POI, PoiComponent } from '@cue/poi';
import { QrIdListPipe } from '@cue/navigation-services';

export type MultiViewRenewControl = {
  qrCodeId: string;
  objects: ControlableObjectBasicInfo[];
  qrCodeListOfResource: string[];
  poi: POI;
};

@Component({
  selector: 'assist-multiview-renew-control',
  imports: [
    NgTemplateOutlet,
    ExpansionPanelComponent,
    ControllableObjectsComponent,
    QrIdListPipe,
    ExpansionPanelTitleDirective,
    PoiComponent,
  ],
  templateUrl: './multiview-renew-control.component.html',
  styleUrl: './multiview-renew-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiviewRenewControlComponent {
  controls = input<MultiViewRenewControl[]>([]);
}
